var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Foreign",
    clipPath: "url(#clip0_464_47785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1818 0H10.6364C10.1845 0 9.81817 0.366328 9.81817 0.818191C9.81817 1.27005 10.1845 1.63638 10.6364 1.63638H15.2066L6.78513 10.0579C6.46567 10.3773 6.46567 10.8954 6.78513 11.2149C6.94485 11.3746 7.15424 11.4545 7.36363 11.4545C7.57302 11.4545 7.78244 11.3746 7.94212 11.2149L16.3637 2.79345V7.36365C16.3637 7.81552 16.73 8.18184 17.1819 8.18184C17.6337 8.18184 18 7.81552 18 7.36365V0.818191C18 0.366328 17.6337 0 17.1818 0Z",
    fill: "#0176D3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9091 8.18178C13.4572 8.18178 13.0909 8.54811 13.0909 8.99997V16.3636H1.63635V4.90905H9C9.45186 4.90905 9.81819 4.54272 9.81819 4.09086C9.81819 3.639 9.45186 3.27271 9 3.27271H0.818191C0.366328 3.27271 0 3.63903 0 4.0909V17.1818C0 17.6336 0.366328 18 0.818191 18H13.9091C14.361 18 14.7273 17.6336 14.7273 17.1818V8.99997C14.7273 8.54811 14.3609 8.18178 13.9091 8.18178Z",
    fill: "#0176D3"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_47785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOut);
export default __webpack_public_path__ + "static/media/LinkOut.917744c83ce604732f3949d881efe69e.svg";
export { ForwardRef as ReactComponent };